import { useEffect } from 'react';
import { useSessionStore } from '@/store/session.store';
import { useShallow } from 'zustand/react/shallow';

export interface ThemeProviderProps {
  children: React.ReactNode;
}

/**
 * Aplica dinámicamente la clase de tema al <html> según el valor de modoFarma
 * en companySettings del session store.
 *
 * modo_farma = 1 → .theme-farma (colores actuales)
 * modo_farma = 0 → .theme-others (colores alternativos)
 */
export const ThemeProvider = ({ children }: ThemeProviderProps) => {
  const modoFarma = useSessionStore(
    useShallow((state) => state.companySettings?.modoFarma)
  );

  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove('theme-farma', 'theme-others');

    if (modoFarma === 1) {
      root.classList.add('theme-farma');
    } else if (modoFarma === 0) {
      root.classList.add('theme-others');
    }
    // Si modoFarma es undefined (no se ha cargado aún), se usan los colores de :root por defecto
  }, [modoFarma]);

  return <>{children}</>;
};
